export default __webpack_public_path__ + "static/media/20210205_170153.ba0c36f3.jpg";